// extracted by mini-css-extract-plugin
export default {"container":"Errors__container___3Osg2","link":"Errors__link___2Jhq-"};